import { computed } from 'vue';
import { useStore } from 'vuex';
import { groupByOption } from '@/types/groupByOption';
import useBoardEmbed from '@/boards/composables/useBoardEmbed';

// Create the Set once outside the function
const STATUS_ICON_PICKER_GROUPS = new Set([
  groupByOption.status,
  groupByOption.statusType,
  groupByOption.tag,
  groupByOption.priority,
  groupByOption.space,
]);

export default function useSwimlanes() {
  const store = useStore();
  const { embeddedBoardAttributes, embed, inEpicBoard } = useBoardEmbed() as any;

  const currentBoardId = computed(() => {
    if (embed) {
      return embeddedBoardAttributes.value?.boardId;
    }
    return store.getters.currentBoardId;
  });

  const boardGroupBy = computed(() => {
    if (embed && !inEpicBoard) {
      return embeddedBoardAttributes.value?.groupBy ?? groupByOption.status;
    }
    return store.getters.getBoardGroupBy(currentBoardId.value) ?? groupByOption.status;
  });

  const boardSubGroupBy = computed(() => {
    if (embed && !inEpicBoard) {
      return embeddedBoardAttributes.value?.subGroupBy ?? groupByOption.status;
    }
    return store.getters.getBoardSubGroupBy(currentBoardId.value) ?? groupByOption.status;
  });

  // Helper function to determine if a group type should show status icon picker
  const shouldShowStatusIconPicker = (groupType: groupByOption) => {
    return STATUS_ICON_PICKER_GROUPS.has(groupType);
  };

  const showStatusIconPickerMainGroup = computed(() =>
    shouldShowStatusIconPicker(boardGroupBy.value)
  );

  const showStatusIconPickerSubGroup = computed(() =>
    shouldShowStatusIconPicker(boardSubGroupBy.value)
  );

  const hideEmptyGroups = computed(() => {
    return embed && !inEpicBoard
      ? embeddedBoardAttributes.value?.hideEmptyGroups
      : store.getters.getHideEmptyGroups(currentBoardId.value);
  });

  return {
    currentBoardId,
    boardGroupBy,
    boardSubGroupBy,
    showStatusIconPickerMainGroup,
    showStatusIconPickerSubGroup,
    store,
    embeddedBoardAttributes,
    embed,
    inEpicBoard,
    hideEmptyGroups,
  };
}
